<template>


  <el-container id="app">

    <!--<elhead v-if="page!='login'">案例大数据分析平台</elhead>-->

    <el-container >
      <el-main>
        <router-view />
      </el-main>
    </el-container>




    <el-footer>版权所有:北京北大英华科技有限公司 京ICP证010230号</el-footer>
  </el-container>
</template>
<script>
  import elhead from '@/components/header'
export default {
  name: 'App',
  components: {
    'elhead':elhead
  },
  data() {
    return {
      aside:[
        {name:'案由',type:'sortId'},
        // {name:'案由1',type:'sortId1'},
        // {name:'案由2',type:'sortId2'},
        // {name:'案由3',type:'sortId3'},
        // {name:'案由4',type:'sortId4'}
      ],
      active:'sortId',
      page:''
    }
  },
  methods: {
    changeType(name){
      if(this.active != name){
        this.active = name;
        this.$refs.chart.getCharts(name)
      }
    }
  },
  mounted(){

    var url = window.location.href;

    if(url.indexOf('own')>-1){
      this.page = 'owm'
    }else if(url.indexOf('reg')>-1){
      this.page = 'reg'
    }else if(url.indexOf('login')>-1){
      this.page = 'login'
    }
  }
}
</script>

<style>
  *{margin: 0;padding: 0}
  html,body,#app{
    height: 100%;
  }
  .el-header{
    background: #1c3664;
    color: #fff;
    font-weight: bold;
    font-size: 26px;
    line-height: 60px;
    text-align: left;
  }
  .el-main{
    padding: 0px!important;
  }
  .el-footer{
    background: #000;
    color: #fff;
    line-height: 60px;
    font-size: 14px;
  }
  .el-aside{
    display: none;
    width: 20%!important;
    min-width: 200px;
    max-width: 300px;
    box-shadow: 0px 2px 2px rgba(0,0,0,0.5);
  }
</style>
<style scoped>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: #E8EBED;
  }
.li{
  line-height: 42px;
  padding-left: 20px;
  text-align: left;
color: #2c3e50;
  cursor: pointer;
  font-weight: bold;
}
  .active{
    background: #fff;

  }
</style>



// WEBPACK FOOTER //
// src/App.vue